export default {
  namespaced: true,
  state: {
    // Permisos para los modulos del sistema
    roleTree: [],
    isSuperAdministrador: false,
    isAdministracion: false,
    isLineas: false,
    isCharter: false,
    isServIntegral: false,
    isFinanzas: false,
    isShipping: false,
  },
  mutations: {
    // Permisos para modulos del sistema
    setRoleStructure(state, payload) {
      state.roleTree = payload;
    },
    setIsSuperAdministrador(state, payload) {
      state.isSuperAdministrador = payload;
    },
    setIsAdministracion(state, payload) {
      state.isAdministracion = payload;
    },
    setIsLineas(state, payload) {
      state.isLineas = payload;
    },
    setIsCharter(state, payload) {
      state.isCharter = payload;
    },
    setIsServIntegral(state, payload) {
      state.isServIntegral = payload;
    },
    setIsFinanzas(state, payload) {
      state.isFinanzas = payload;
    },
    setIsShipping(state, payload) {
      state.isShipping = payload;
    },

    setIsLoadPage(state, payload) {
      state.isLoadPage = payload;
    },

    setIsAdmin(state, payload) {
      state.isAdmin = payload;
    },
    //
  },
  actions: {
    // Permisos para secciones del sistema
    actionSetRoleStructure({ commit }, data) {
      commit("setRoleStructure", data);
    },
    AccionCambiarIsSuperAdministrador({ commit }, data) {
      commit("setIsSuperAdministrador", data);
    },

    AccionCambiarIsAdministracion({ commit }, data) {
      commit("setIsAdministracion", data);
    },

    AccionCambiarIsLineas({ commit }, data) {
      commit("setIsLineas", data);
    },

    AccionCambiarIsCharter({ commit }, data) {
      commit("setIsCharter", data);
    },

    AccionCambiarIsServIntegral({ commit }, data) {
      commit("setIsServIntegral", data);
    },

    AccionCambiarIsFinanzas({ commit }, data) {
      commit("setIsFinanzas", data);
    },

    AccionCambiarIsShipping({ commit }, data) {
      commit("setIsShipping", data);
    },

    //
  },
};
